import _ from 'lodash';
import $ from 'jquery';
import widgetFactory from '../../widgetFactory';

import phoneInput from './components/phoneInput';

export const paymentTypes = {
  CREDIT_CARD: 'credit_card',
  PAYPAL: 'paypal',
};

export default widgetFactory('premiumShopAbstractForm', {
  _create: function (baseClassname) {
    this._super(baseClassname);

    this._hasPayment = true;
    this.isValid = false;

    this.elements.$submitButton = $('button[type=submit]', this.element);
    this.elements.$paymentPanel = this.getWidgetElement('paymentPanel');
    this.elements.$mainFirstName = this.getWidgetElement('firstName');
    this.elements.$mainLastName = this.getWidgetElement('lastName');
    this.elements.$phoneNumber = this.getWidgetElement('phoneNumber');
    this.elements.$country = this.getWidgetElement('country');

    if (!_.isEmpty(this.elements.$phoneNumber)) {
      phoneInput.create(
        {
          countryElement: this.elements.$country,
        },
        this.getWidgetElement('phoneNumber')
      );
    }
  },

  _updateSubmitButton() {
    this.elements.$submitButton.prop('disabled', !this.isValid);
  },

  hidePaymentWidget() {
    this._hasPayment = false;
    this.elements.$paymentPanel.hide();
    this.validate();
  },

  showPaymentWidget() {
    this._hasPayment = true;
    this.elements.$paymentPanel.show();
    this.validate();
  },

  enablePaymentTypes() {
    throw 'need implementation of "enablePaymentTypes" method';
  },

  validate() {
    throw 'need implementation of "validate" method';
  },
});
